module.exports = __webpack_public_path__ + "static/jc04657-preparation-administration-3-885fb0845414a1859739a7113ee86ab1.png";